<template>
  <Notification
    :description="
      $t(`plus_notification_subscription_expires`, {
        ExpirationDate: expiryDate,
      })
    "
    v-bind="$attrs"
  >
    <template #ctaContent>
      <div class="tw:mt-3 tw:md:mt-0 tw:shrink-0">
        <BaseLinkButton
          size="medium"
          class="tw:w-full tw:font-bold tw:text-blue-800 tw:text-nowrap"
          @click="reactivate(selectedAccommodationId)"
        >
          <span>{{ hasAdminOrSupport ? $t('plus_notification_cta_reactivate') : $t('rc_admin_log_in_cta') }}</span>
        </BaseLinkButton>
      </div>
    </template>
  </Notification>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import Notification from './Notification.vue'
import BaseLinkButton from '@/components/base/buttons/BaseLinkButton.vue'

import { useStudioPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useStudioPlusReactivation'
import { useProToPlusReactivation } from '@/components/billing/premiumProducts/reactivation/useProToPlusReactivation'
import { selectedAccommodationId } from '@/layouts/queries'
import { useSessionValues } from '@/composables/useSessionValues'
import { useFormatting } from '@/composables/useFormatting'

const store = useStore()
const { formatDate } = useFormatting()
const { hasAdminOrSupport } = useSessionValues()
const { openReactivationModal } = useStudioPlusReactivation()
const { openProToPlusModal } = useProToPlusReactivation()
const props = defineProps({
  extraParameters: {
    type: Object,
    required: true,
    default: null,
  },
})

const expiryDate = computed(() => {
  const end = props.extraParameters?.endDate
  if (!end) return ''

  const formatted = formatDate(end, { timeZone: 'UTC' })
  return formatted === '-' ? '' : formatted
})

const isProUser = computed(() => props.extraParameters?.productType === 'PRO')

const reactivate = itemId => {
  if (hasAdminOrSupport.value) {
    if (isProUser.value) {
      openProToPlusModal(itemId, 'notification_pro_cancelled')
    } else {
      openReactivationModal(itemId, 'notification-plus-cancelled')
    }
  } else {
    store.dispatch('session/logout', '/?loginAsAdmin=true&isReactivationOpen=true')
  }
}
</script>
